import Home from "./components";

export default Home;
